module.exports = __webpack_public_path__ + "img/more_bg.58d5c7fa.png";